import React from "react"

import Print from "pages/print"

const printRoutes = [
  {
    path: "/print",
    component: <Print />
  }
]

export default printRoutes